import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeviceRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" {...props}>
    <rect width={12} height={12} x={0.25} fill="#DC1212" rx={6} />
    <path
      fill="#fff"
      d="m7.601 9.205-1.25-2.556h-.9v2.556H4.198V2.797H6.71q.486 0 .873.162.387.153.657.423.27.26.405.62.144.352.144.757 0 .342-.099.612-.09.27-.252.486a1.8 1.8 0 0 1-.819.585L9.05 9.205zm-.063-4.446a.8.8 0 0 0-.252-.612q-.242-.234-.657-.234H5.45v1.692h1.18q.413 0 .656-.234a.8.8 0 0 0 .252-.612"
    />
  </svg>
);
export default SvgDeviceRight;
